import { useState } from "react";
import {
  Box,
  Button,
  Link,
  Modal as MUIModal,
  Stack,
  Typography,
} from "@mui/material";
import { ModalCloseIcon, ThumbsDownIcon, ThumbsUpIcon } from "../../@lib/icons";
import { useNavigate } from "react-router-dom";
import { useLanguageTranslator } from "../useLanguageContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 530,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  py: 3,
  px: 1,
};

function SuccessCreation({ isOpen, newCreationPath, viewPath, module }: any) {
  const navigate = useNavigate();
  const { translator } = useLanguageTranslator();

  function onClickHandler(module: any, id: any) {
    if (module === "success") {
      navigate(`${viewPath}${id}`);
      return;
    }
  }

  return (
    <MUIModal
      open={isOpen?.status}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Stack
          sx={{ display: "flex", justifyContent: "end", alignItems: "end" }}
        >
          <Link
            href={newCreationPath}
            sx={{
              padding: "0px",
              minWidth: "auto",
            }}
          >
            <ModalCloseIcon />
          </Link>
        </Stack>
        <Stack
          direction="column"
          sx={{ padding: "10px 60px" }}
          alignItems="center"
        >
          {isOpen?.module === "success" ? <ThumbsUpIcon /> : <ThumbsDownIcon />}
          <Typography
            id="modal-modal-description"
            variant="h6"
            component="h2"
            sx={{ fontSize: "16px", textAlign: "center" }}
          >
            {isOpen?.module === "success"
              ? translator("moduleCreated", { module: translator(`confirmationItems.${module?.toLowerCase()}`) })
              : ""}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="center" gap={1} mt={2}>
          <Button
            sx={{
              backgroundColor: "#52D777",
              color: "white",
              padding: "7px 50px",
            }}
            onClick={() => onClickHandler(isOpen?.module, isOpen?.currId)}
          >
            {translator(`dashboardTableHead.View`)} {translator(`confirmationItems.${module?.toLowerCase()}`)}
          </Button>
          <Link
            href={newCreationPath}
            sx={{
              backgroundColor: "#F6A000",
              color: "white",
              padding: "7px 50px",
              borderRadius: "10px",
            }}
          >
            {translator(`Create Another`)}
          </Link>
        </Stack>
      </Box>
    </MUIModal>
  );
}

export { SuccessCreation };
